import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import Loader from '../../Loader/Loader';

import { removeListing } from '../../../actions/siteadmin/ListingManagement/removeListing';
import { addListToRecommended, removeListFromRecommended } from '../../../actions/siteadmin/ListingManagement/manageRecommend';
import listingsQuery from './listingsQuery.graphql';
import messages from '../../../locale/jsonMessages';
import { changeFilterSettings } from '../../../actions/siteadmin/ManageCars/manageListingData';
import { withQuery } from '../../../hoc/withGraphql';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { demoRestriction, demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { censorEmail, decode } from '../../../helpers/secureEmail';
import { dateFormat } from '../../../config';

import cs from '../../../components/commonStyle.css';
import s from './ListingManagement.css';
class ListingManagement extends React.Component {

  static propTypes = {
    getAllListings: PropTypes.array,
    title: PropTypes.string.isRequired,
    addListToRecommended: PropTypes.func.isRequired,
    removeListFromRecommended: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      listStatus: 2,
      typing: false,
      typingTimeout: 0,
      isRestrict: false
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  paginationData = (currentPage) => {
    const { getAllListings: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }
  handleClick = (searchList) => {
    const { getAllListings: { refetch }, setStateVariable } = this.props;
    const { currentPage } = this.state;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    setStateVariable(variables);
    refetch(variables);
  }
  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }
  handleChange = (listStatus) => {
    const { getAllListings: { refetch }, setStateVariable, changeFilterSettings, currentPage, searchList } = this.props;
    changeFilterSettings(currentPage, searchList, listStatus)
    let variables = { currentPage: 1, searchList, listStatus };
    setStateVariable(variables);
    refetch(variables);
  }
  deleteListing = async (id, type) => {
    const { removeListing, currentPage, demoRestriction } = this.props;
    const { getAllListings: { refetch, getAllListings }, setStateVariable } = this.props;
    let variables = { currentPage: currentPage > 1 && getAllListings?.usersData?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({ restrictType: 'listing', restrictValue: id });
    if (isRestrict) return;
    const response = await removeListing(id, type);
    if (response?.status == 200) {
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.adminTitleLabel) },
      { data: formatMessage(messages.carOwnerName) },
      { data: formatMessage(messages.carOwnerEmail) },
      { data: formatMessage(messages.address) },
      { data: formatMessage(messages.city) },
      { data: formatMessage(messages.stateLabel) },
      { data: formatMessage(messages.country) },
      { data: formatMessage(messages.createdDate) },
      { data: formatMessage(messages.recommendLabel) },
      { data: formatMessage(messages.publishedLabel) },
      { data: formatMessage(messages.ready) },
    ]
  };

  tbody = (props) => {
    const { getAllListings: { getAllListings }, locale, dynamicTitle } = props;
    const { currentPage, searchList, listStatus, addListToRecommended, removeListFromRecommended } = props;
    const { formatMessage } = this.props.intl;
    const { isRestrict } = this.state;

    return getAllListings?.usersData.map(value => {
      let dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: value?.id });
      return {
        id: value?.id,
        data: [
          { data: value.id },
          {
            data:
              <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
                <a href={"/cars/" + value.id} target='_blank'>
                  {dynamicListTitle || (value?.title ? value.title : value.settingsData[0]?.listsettings?.itemName + " in " + value?.city)}
                </a>

                <TableAction
                  onClickDelete={() => this.deleteListing(value.id, "admin")}
                  showDelete={true}
                  showView={true}
                  newLink={"/cars/" + value.id}
                  showEdit
                  editNewLink={'/become-a-owner/' + value.id + '/home'}
                />
              </div>
          },
          { data: value?.user?.profile?.firstName },
          { data: !isRestrict ? decode(value?.user?.encryptEmail) : censorEmail(decode(value?.user?.encryptEmail)) },
          { data: value.street + ', ' + value.city + ', ' + value.state + ', ' + value.country + ', ' + value.zipcode },
          { data: value?.city },
          { data: value?.state },
          { data: value?.country },
          { data: moment(parseInt(value?.createdAt)).format(dateFormat?.shortDateFormat) },
          {
            data: <>
              {
                value.recommend != null &&
                <div>
                  <a href="javascript:void(0)" onClick={() => removeListFromRecommended(value.id, currentPage, searchList, listStatus)} >
                    <FormattedMessage  {...messages.remove} />
                  </a>
                </div>
              }
              {
                value.recommend == null &&
                <div>
                  <a href="javascript:void(0)" onClick={() => addListToRecommended(value.id, currentPage, searchList, listStatus)} >
                    <FormattedMessage  {...messages.setLabel} />
                  </a>
                </div>
              }
            </>
          },
          { data: value.isPublished ? formatMessage(messages.yesLabel) : formatMessage(messages.noLabel) },
          { data: value.isReady ? formatMessage(messages.yesLabel) : formatMessage(messages.noLabel) },
        ]
      }
    })
  }
  listFilters = () => {
    const { formatMessage } = this.props.intl;
    return [
      { value: "2", label: formatMessage(messages.all) },
      { value: "1", label: formatMessage(messages.listed) },
      { value: "0", label: formatMessage(messages.unListed) }
    ]
  }

  render() {
    const { getAllListings: { loading, getAllListings } } = this.props;
    const { currentPage, searchList, listStatus } = this.props;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />
    }

    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageListing)}
          isExport
          exportLink={`/export-admin-data?type=listings&listStatus=${listStatus}&search=${searchList}`}
          isSearch
          onSearch={this.handleSearchChange}
          listFilters={this.listFilters()}
          onChange={this.handleChange}
        />
        {
          !loading && getAllListings?.usersData?.length > 0
          && <div>
            <CustomPagination
              total={getAllListings.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.listings)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({
  locale: state?.intl?.locale,
  dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {
  removeListing,
  addListToRecommended,
  removeListFromRecommended,
  changeFilterSettings,
  demoRestriction,
  demoRestrictionEncode
};
export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(listingsQuery, {
    name: 'getAllListings',
    options: (props) => ({
      variables: {
        currentPage: 1,
        searchList: '',
        listStatus: 2
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(ListingManagement);